import { render, staticRenderFns } from "./ModalAddFile.vue?vue&type=template&id=f79793b8&scoped=true"
import script from "./ModalAddFile.vue?vue&type=script&lang=js"
export * from "./ModalAddFile.vue?vue&type=script&lang=js"
import style0 from "./ModalAddFile.vue?vue&type=style&index=0&id=f79793b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79793b8",
  null
  
)

export default component.exports